@if (attribute) {
  <div [class.invisible]="isLoading">
    <app-field-label [attribute]="attribute"
    [passportId]="passportId"></app-field-label>
    <ix-select
      [formControl]="control"
      [ngClass]="{'ix-invalid': control.errors}"
      class="w-100"
      id="{{ attribute.name }}">
      @for (option of attribute.options; track option) {
        <ix-select-item
          label="{{option.label | translate}}"
          value="{{option.value}}">
        </ix-select-item>
      }
    </ix-select>
  </div>
}
<ix-spinner [class.d-none]="!isLoading"></ix-spinner>
